// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/OCR-A-Std-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}

body {
  background-color: #f4f5f7;
  font-family: hoss-round, sans-serif;
  letter-spacing: 0.5px;
  font-size: 14px;
  color: gray;
  opacity: 1;
}

.btn {
  font-size: 14px;
  /* border: 1px solid #707070; */
  background-color: #016aa7;
  color: #ffffff;
  height: 40px;
  box-shadow: none;
}

.bg {
  background-color: #f4f5f7 !important;
  margin-top: 0px !important;
  width: 120px;
}

.bg-blue {
  background-color: #016aa7 !important;
}

.bg-light-blue {
  background-color: #016aa719;
}

.bg-dark-blue {
  background-color: #004065;
}

.text-blue {
  color: #016aa7 !important;
}

.border-blue {
  border-color: #016aa7 !important;
}

.fs-7 {
  font-size: 0.7rem;
}

.h-5 {
  height: 20px;
}

.h-200 {
  height: 300px;
}

.form-control {
  border-color: rgb(213, 213, 213);
  background-color: #f4f5f7;
  font-size: 12px;
  padding: 10px;
  color: rgb(119, 119, 119);
  box-shadow: none;
}

select {
  box-shadow: none;
}

a {
  color: #000000;
  font-size: 14px;
  font-weight: 600;
}

.scroll {
  border: 1px solid #016aa7 !important;
  color: #016aa7;
  height: 30px;
  padding: 7px;
  padding-top: 3px;
  margin-top: 14px;
  cursor: pointer;
}

.border-dashed-blue {
  border: 1px dashed blue;
}

.search {
  font-size: 10px;
  margin-top: 20px;
  padding: 8px;
  border-radius: 0 !important;
}

.fa-search {
  position: absolute;
  left: 10px;
  top: 15px;
  color: #016aa7;
}

@font-face {
  font-family: "OCR";
  src: local("OCR-A-Std-Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  -webkit-transition: background-color 600000s 0s, color 600000s 0s;
  transition: background-color 600000s 0s, color 600000s 0s;
}
input[data-autocompleted] {
  background-color: transparent !important;
}

.btn-check:focus + .btn,
.btn:focus {
  box-shadow: none;
}

label {
  color: rgb(119, 119, 119);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB;8DACgE;AAClE;;AAEA;;EAEE,iEAAyD;EAAzD,yDAAyD;AAC3D;AACA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: #f4f5f7;\n  font-family: hoss-round, sans-serif;\n  letter-spacing: 0.5px;\n  font-size: 14px;\n  color: gray;\n  opacity: 1;\n}\n\n.btn {\n  font-size: 14px;\n  /* border: 1px solid #707070; */\n  background-color: #016aa7;\n  color: #ffffff;\n  height: 40px;\n  box-shadow: none;\n}\n\n.bg {\n  background-color: #f4f5f7 !important;\n  margin-top: 0px !important;\n  width: 120px;\n}\n\n.bg-blue {\n  background-color: #016aa7 !important;\n}\n\n.bg-light-blue {\n  background-color: #016aa719;\n}\n\n.bg-dark-blue {\n  background-color: #004065;\n}\n\n.text-blue {\n  color: #016aa7 !important;\n}\n\n.border-blue {\n  border-color: #016aa7 !important;\n}\n\n.fs-7 {\n  font-size: 0.7rem;\n}\n\n.h-5 {\n  height: 20px;\n}\n\n.h-200 {\n  height: 300px;\n}\n\n.form-control {\n  border-color: rgb(213, 213, 213);\n  background-color: #f4f5f7;\n  font-size: 12px;\n  padding: 10px;\n  color: rgb(119, 119, 119);\n  box-shadow: none;\n}\n\nselect {\n  box-shadow: none;\n}\n\na {\n  color: #000000;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.scroll {\n  border: 1px solid #016aa7 !important;\n  color: #016aa7;\n  height: 30px;\n  padding: 7px;\n  padding-top: 3px;\n  margin-top: 14px;\n  cursor: pointer;\n}\n\n.border-dashed-blue {\n  border: 1px dashed blue;\n}\n\n.search {\n  font-size: 10px;\n  margin-top: 20px;\n  padding: 8px;\n  border-radius: 0 !important;\n}\n\n.fa-search {\n  position: absolute;\n  left: 10px;\n  top: 15px;\n  color: #016aa7;\n}\n\n@font-face {\n  font-family: \"OCR\";\n  src: local(\"OCR-A-Std-Regular\"),\n    url(\"./assets/fonts/OCR-A-Std-Regular.ttf\") format(\"truetype\");\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n  transition: background-color 600000s 0s, color 600000s 0s;\n}\ninput[data-autocompleted] {\n  background-color: transparent !important;\n}\n\n.btn-check:focus + .btn,\n.btn:focus {\n  box-shadow: none;\n}\n\nlabel {\n  color: rgb(119, 119, 119);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
